export enum paymentIssueResolutionViewModes {
  acceptAsPartialPaymentView = "acceptAsPartialPaymentView",
  refundToCustomerView = "refundToCustomerView",
  settleToMerchantBalanceView = "settleToMerchantBalanceView",
  redirectToInvoiceView = "redirectToInvoiceView",
  // xxxxxxxxxView = "xxxxxxxxxView",
}
